module.exports = __webpack_public_path__ + "static/media/calculator-black.a1cf9c50.svg";